import React, { useEffect, useState } from 'react';
import { crearRecordatorio, marcarRecordatorio, eliminarRecordatorio } from '../services/metasService';
import { estadoAvisos, activarAvisos, necesitaInstalar } from '../services/avisosPedidos';
import { mensajeAmigable } from '../utils/errores';
import { useToast } from '../context/ToastContext';

const ACENTO = 'var(--color-primario,#DB2777)';
const tarjeta = { backgroundColor: 'white', borderRadius: '16px', padding: '16px', border: '1px solid #EEE9F8', marginBottom: '12px' };
const REPETIR = { '': 'Una vez', diario: 'Todos los días', semanal: 'Cada semana', mensual: 'Cada mes' };

const paraInput = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
const enUnaHora = () => { const d = new Date(Date.now() + 3600000); d.setMinutes(0, 0, 0); return d; };
const fechaBonita = (iso) => {
  const d = new Date(iso); const hoy = new Date();
  const man = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 1);
  const hora = d.toLocaleTimeString('es-HN', { hour: 'numeric', minute: '2-digit' });
  if (d.toDateString() === hoy.toDateString()) return `Hoy, ${hora}`;
  if (d.toDateString() === man.toDateString()) return `Mañana, ${hora}`;
  return `${d.toLocaleDateString('es-HN', { weekday: 'short', day: 'numeric', month: 'short' })}, ${hora}`;
};

// ⏰ Pendientes y recordatorios: llegan como aviso al celular a su hora
// (cron cada 15 min, sql/125), aunque Kontrol esté cerrado.
export default function MetasPendientes({ recordatorios, setRecordatorios, estrategias }) {
  const { mostrarToast } = useToast();
  const [form, setForm] = useState({ titulo: '', cuando: paraInput(enUnaHora()), repetir: '', estrategiaId: '', nota: '' });
  const [avisos, setAvisos] = useState(null);
  const [verHechos, setVerHechos] = useState(false);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => { estadoAvisos().then(setAvisos).catch(() => setAvisos('no-soportado')); }, []);

  const activar = async () => {
    try { await activarAvisos(); setAvisos('activados'); mostrarToast('🔔 ¡Listo! Te llegarán tus recordatorios y el resumen de cada mañana', 'exito', 6000); } catch (e) { mostrarToast(e.message, 'error', 6000); }
  };

  const agregar = async (ev) => {
    ev.preventDefault();
    if (!form.titulo.trim()) { mostrarToast('Escribe qué quieres que te recordemos', 'error'); return; }
    if (!form.cuando) { mostrarToast('Elige el día y la hora', 'error'); return; }
    setGuardando(true);
    try {
      const r = await crearRecordatorio({ ...form, repetir: form.repetir || null });
      setRecordatorios((x) => [...x, r].sort((a, b) => new Date(a.cuando) - new Date(b.cuando)));
      setForm({ titulo: '', cuando: paraInput(enUnaHora()), repetir: '', estrategiaId: '', nota: '' });
      mostrarToast(`⏰ Te lo recordamos ${fechaBonita(r.cuando).toLowerCase()}`, 'exito');
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setGuardando(false); }
  };

  const marcar = async (r) => {
    try {
      await marcarRecordatorio(r.id, !r.hecho);
      setRecordatorios((x) => x.map((y) => (y.id === r.id ? { ...y, hecho: !r.hecho } : y)));
      if (!r.hecho) mostrarToast('✅ ¡Un pendiente menos!', 'exito');
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const borrar = async (r) => {
    try { await eliminarRecordatorio(r.id); setRecordatorios((x) => x.filter((y) => y.id !== r.id)); } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const ahora = new Date();
  const finHoy = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate() + 1);
  const abiertos = recordatorios.filter((r) => !r.hecho);
  const grupos = [
    ['⚠️ Atrasados', abiertos.filter((r) => new Date(r.cuando) < new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate()))],
    ['📌 Hoy', abiertos.filter((r) => { const d = new Date(r.cuando); return d >= new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate()) && d < finHoy; })],
    ['🗓️ Próximos', abiertos.filter((r) => new Date(r.cuando) >= finHoy)],
  ];
  const hechos = recordatorios.filter((r) => r.hecho);
  const nombreEstrategia = (id) => estrategias.find((e) => e.id === id)?.titulo;

  const fila = (r) => (
    <div key={r.id} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '9px 0', borderBottom: '1px solid #F3F4F6' }}>
      <input type="checkbox" checked={r.hecho} onChange={() => marcar(r)} aria-label={`Hecho: ${r.titulo}`} style={{ width: '20px', height: '20px', marginTop: '2px', accentColor: '#059669' }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <b style={{ fontSize: '14px', textDecoration: r.hecho ? 'line-through' : 'none', color: r.hecho ? '#9CA3AF' : '#1F1A2E' }}>{r.titulo}</b>
        <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#6B7280' }}>
          {fechaBonita(r.cuando)}{r.repetir ? ` · 🔁 ${REPETIR[r.repetir]}` : ''}{r.estrategia_id && nombreEstrategia(r.estrategia_id) ? ` · 🧭 ${nombreEstrategia(r.estrategia_id)}` : ''}
        </p>
        {r.nota && <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#9CA3AF' }}>{r.nota}</p>}
      </div>
      <button onClick={() => borrar(r)} className="k-btn-soft" style={{ fontSize: '12px', padding: '4px 8px' }} aria-label="Borrar">🗑️</button>
    </div>
  );

  return (
    <div>
      {avisos && avisos !== 'activados' && (
        <div style={{ ...tarjeta, background: '#FFFBEB', borderColor: '#FDE68A' }}>
          <b>🔔 Activa los avisos en este celular</b>
          <p style={{ margin: '4px 0 8px', fontSize: '13px', color: '#92400E' }}>
            {avisos === 'no-soportado' ? 'Este navegador no permite avisos. Abre Kontrol en Chrome o desde el ícono instalado.'
              : avisos === 'bloqueados' ? 'Los bloqueaste: actívalos en los ajustes del navegador para este sitio.'
                : necesitaInstalar() ? 'En iPhone, primero instala Kontrol en tu pantalla de inicio y ábrelo desde el ícono.'
                  : 'Así te llegan tus recordatorios a su hora y cada mañana el resumen de cómo vas con tu meta, aunque Kontrol esté cerrado.'}
          </p>
          {avisos === 'apagados' && !necesitaInstalar() && (
            <button onClick={activar} style={{ padding: '9px 16px', borderRadius: '10px', border: 'none', background: '#D97706', color: 'white', fontWeight: 700, cursor: 'pointer' }}>Activar avisos</button>
          )}
        </div>
      )}
      {avisos === 'activados' && <p style={{ margin: '0 0 10px', fontSize: '12px', color: '#047857' }}>🔔 Avisos activados en este dispositivo: te llegan tus recordatorios y el resumen de cada mañana (7 a. m.).</p>}

      <form onSubmit={agregar} style={tarjeta}>
        <p style={{ margin: '0 0 10px', fontWeight: 800, fontSize: '16px' }}>➕ Nuevo pendiente</p>
        <input className="k-input" value={form.titulo} maxLength={140} onChange={(e) => setForm({ ...form, titulo: e.target.value })}
          placeholder="¿Qué tienes que hacer? (ej: pagar al proveedor, publicar la promo, reponer brasieres)" style={{ marginBottom: '8px' }} />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '8px' }}>
          <label style={{ fontSize: '12px', fontWeight: 700, color: '#374151' }}>Día y hora
            <input type="datetime-local" value={form.cuando} onChange={(e) => setForm({ ...form, cuando: e.target.value })}
              style={{ display: 'block', width: '100%', boxSizing: 'border-box', marginTop: '4px', padding: '9px', borderRadius: '10px', border: '1px solid #D1D5DB', fontSize: '14px' }} />
          </label>
          <label style={{ fontSize: '12px', fontWeight: 700, color: '#374151' }}>Repetir
            <select value={form.repetir} onChange={(e) => setForm({ ...form, repetir: e.target.value })}
              style={{ display: 'block', width: '100%', marginTop: '4px', padding: '9px', borderRadius: '10px', border: '1px solid #D1D5DB', fontSize: '14px', backgroundColor: 'white' }}>
              {Object.entries(REPETIR).map(([k, t]) => <option key={k} value={k}>{t}</option>)}
            </select>
          </label>
          {estrategias.length > 0 && (
            <label style={{ fontSize: '12px', fontWeight: 700, color: '#374151' }}>Para la estrategia (opcional)
              <select value={form.estrategiaId} onChange={(e) => setForm({ ...form, estrategiaId: e.target.value })}
                style={{ display: 'block', width: '100%', marginTop: '4px', padding: '9px', borderRadius: '10px', border: '1px solid #D1D5DB', fontSize: '14px', backgroundColor: 'white' }}>
                <option value="">Ninguna</option>
                {estrategias.filter((e) => e.estado !== 'hecha').map((e) => <option key={e.id} value={e.id}>{e.titulo}</option>)}
              </select>
            </label>
          )}
        </div>
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '8px' }}>
          {[['En 1 hora', enUnaHora()], ['Mañana 9 a. m.', (() => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(9, 0, 0, 0); return d; })()], ['Lunes 8 a. m.', (() => { const d = new Date(); d.setDate(d.getDate() + ((8 - d.getDay()) % 7 || 7)); d.setHours(8, 0, 0, 0); return d; })()]].map(([t, d]) => (
            <button key={t} type="button" onClick={() => setForm({ ...form, cuando: paraInput(d) })} className="k-btn-soft" style={{ fontSize: '12px' }}>{t}</button>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
          <button type="submit" disabled={guardando} style={{ padding: '10px 18px', borderRadius: '10px', border: 'none', background: ACENTO, color: 'white', fontWeight: 700, cursor: 'pointer' }}>{guardando ? 'Guardando…' : '⏰ Guardar pendiente'}</button>
        </div>
      </form>

      <div style={tarjeta}>
        {abiertos.length === 0 && <p style={{ margin: 0, color: '#9CA3AF' }}>🎉 No tienes pendientes. ¡Todo al día!</p>}
        {grupos.map(([t, lista]) => lista.length > 0 && (
          <div key={t} style={{ marginBottom: '8px' }}>
            <p style={{ margin: '6px 0 2px', fontSize: '13px', fontWeight: 800, color: t.startsWith('⚠️') ? '#B91C1C' : '#374151' }}>{t} ({lista.length})</p>
            {lista.map(fila)}
          </div>
        ))}
        {hechos.length > 0 && (
          <button onClick={() => setVerHechos((v) => !v)} className="k-btn-soft" style={{ fontSize: '12px', marginTop: '6px' }}>
            {verHechos ? 'Ocultar hechos' : `Ver hechos (${hechos.length})`}
          </button>
        )}
        {verHechos && hechos.map(fila)}
      </div>
    </div>
  );
}
